import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';

interface PropsDrawer {
  children: any;
  isOpen: boolean;
  onClose: () => void;
  placement: 'top' | 'left' | 'bottom' | 'right';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

export function DrawerComponent({
  children,
  onClose,
  isOpen,
  placement,
  size,
}: PropsDrawer) {
  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement={placement}
        onClose={onClose}
        size={size}
      >
        <DrawerOverlay />
        <DrawerContent bg="gray.800">
          <DrawerCloseButton />
          {children}
        </DrawerContent>
      </Drawer>
    </>
  );
}
